import type { TabItem } from '../Tabs/Tabs.types'

export type { TabItem }

export type ChartingTabsPreviewState = 'default' | 'hover' | 'selected'

export const CHARTING_TABS_PREVIEW_STATES: ChartingTabsPreviewState[] = [
  'default',
  'hover',
  'selected',
]

export const CHARTING_TABS_PREVIEW_STATE_LABELS: Record<
  ChartingTabsPreviewState,
  string
> = {
  default: 'Default',
  hover: 'Hover',
  selected: 'Selected',
}

export const CHARTING_TABS_DEMO_ITEMS: TabItem[] = [
  { id: 'tab-1', label: 'Tab 1' },
  { id: 'tab-2', label: 'Tab 2' },
  { id: 'tab-3', label: 'Tab 3' },
]

export const CHARTING_TABS_LIVE_ITEMS: TabItem[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'details', label: 'Details' },
  { id: 'history', label: 'History' },
]

export type ChartingTabsProps = {
  items?: TabItem[]
  value?: string
  defaultValue?: string
  disabled?: boolean
  className?: string
  /** Dark surface styling. */
  darkMode?: boolean
  /**
   * Static visual state for the design-system showcase only.
   * Default = first tab selected; Hover = first selected + second hovered;
   * Selected = second tab selected.
   */
  previewState?: ChartingTabsPreviewState
  onChange?: (tabId: string) => void
}
